import {createSelector} from 'reselect';
import {getTranslations, getContactOwnerForm, getTravelerFeatures} from './store';
import {
    getBrandName,
    getHumanReadableBrandName,
    getPrivacyPolicyUrl,
    getTermsAndConditionsUrl,
    getMarketingOptInType
} from './system';
import {isInquiryModalOpen} from './modalStates';
import {getUserData} from './userData';
import {labelMaker} from '../../server/utils/labelMaker';

/* eslint-disable complexity */
const getContactOwnerFormLabels = createSelector(
    [getTranslations, getHumanReadableBrandName, getContactOwnerForm, getTravelerFeatures],
    (trans, humanReadableBrandName, contactOwnerForm, travelerFeatures) => {
        const {invalid, isFormValid, touched} = contactOwnerForm;

        const showFirstNameErrorMsg =
            !isFormValid && touched.has('firstName') && invalid.has('firstName');
        const showLastNameErrorMsg =
            !isFormValid && touched.has('lastName') && invalid.has('lastName');
        const showEmailAddressErrorMsg =
            !isFormValid && touched.has('emailAddress') && invalid.has('emailAddress');
        const showMessageErrorMsg =
            !isFormValid && touched.has('message') && invalid.has('message');
        const showTermsAndConditionsErrorMsg =
            !isFormValid &&
            touched.has('termsAndConditionsAgreed') &&
            invalid.has('termsAndConditionsAgreed');

        return {
            firstName: trans.firstName,
            lastName: trans.lastName,
            emailAddress: trans.emailAddress,
            message: trans.message,
            firstNameErrorMsg: showFirstNameErrorMsg ? trans.firstNameErrorMsg : '',
            lastNameErrorMsg: showLastNameErrorMsg ? trans.lastNameErrorMsg : '',
            emailAddressErrorMsg: showEmailAddressErrorMsg ? trans.emailAddressErrorMsg : '',
            messageErrorMsg: showMessageErrorMsg ? trans.messageErrorMsg : '',
            termsAndConditionsAgreedErrorMsg: showTermsAndConditionsErrorMsg
                ? trans.termsAndConditionsAgreedErrorMsg
                : '',
            phoneNumber: travelerFeatures.inquiryPhoneIsMobile
                ? trans.mobileNumber
                : trans.phoneNumber,
            inquirySubscribeOptInText: labelMaker(trans.inquirySubscribeOptInText, {
                brand: humanReadableBrandName
            }),
            inquirySubscribeOptOutText: labelMaker(trans.inquirySubscribeOptOutText, {
                brand: humanReadableBrandName
            })
        };
    }
);
/* eslint-enable complexity */

const getContactOwnerFormHasTripDetailsErrors = createSelector(
    [getContactOwnerForm, isInquiryModalOpen],
    (contactOwnerForm, inquiryModalOpen) => {
        const hasInvalidGuests = !!contactOwnerForm.invalid.has('guests');

        return inquiryModalOpen ? hasInvalidGuests : null;
    }
);

const getContactOwnerFormDetails = createSelector(
    [
        getBrandName,
        getContactOwnerForm,
        getContactOwnerFormLabels,
        getPrivacyPolicyUrl,
        getTermsAndConditionsUrl,
        getTravelerFeatures,
        getUserData,
        getMarketingOptInType
    ],
    (
        brandName,
        contactOwnerForm,
        contactOwnerFormLabels,
        privacyPolicyUrl,
        termsAndConditionsUrl,
        travelerFeatures,
        userData,
        marketingOptInType
    ) => {
        const {
            firstName,
            lastName,
            countryCode,
            countryName,
            phoneNumber,
            emailAddress,
            message,
            termsAndConditionsAgreed,
            shouldSubscribeToNews,
            isSubscriptionChecked,
            isFormValid
        } = contactOwnerForm;
        const {termsAndConditionsRequired} = travelerFeatures;
        return {
            labels: contactOwnerFormLabels,
            firstName,
            lastName,
            brandName,
            countryCode,
            countryName,
            phoneNumber,
            emailAddress,
            message,
            privacyPolicyUrl,
            termsAndConditionsAgreed,
            termsAndConditionsRequired,
            termsAndConditionsUrl,
            shouldSubscribeToNews,
            isFormValid,
            isSubscriptionChecked,
            userData,
            marketingOptInType
        };
    }
);

export default getContactOwnerFormDetails;
export {
    getContactOwnerFormLabels,
    getContactOwnerFormDetails,
    getContactOwnerFormHasTripDetailsErrors
};
